import {
  UPDATE_RESERVATION_CART_REQUEST,
  GET_RESERVATION_CART_REQUEST,
  CREATE_RESERVATION_CART_REQUEST,
  UPDATE_AND_PROCESS_RESERVATION_CART_REQUEST,
  PROCESS_RESERVATION_CART_REQUEST,
  RESERVATION_CHECKOUT_STEP_REQUEST
} from './constants';

export const createReservationCart = (reservationCart, successFunction) => ({
  type: CREATE_RESERVATION_CART_REQUEST,
  reservationCart,
  successFunction
});

export const getReservationCart = () => ({
  type: GET_RESERVATION_CART_REQUEST
});

export const updateReservationCart = (reservationCart, successFunction) => ({
  type: UPDATE_RESERVATION_CART_REQUEST,
  reservationCart,
  successFunction
});

export const updateAndProcessReservationCart = (
  reservationCart,
  successFunction
) => ({
  type: UPDATE_AND_PROCESS_RESERVATION_CART_REQUEST,
  reservationCart,
  successFunction
});

export const processReservationCart = (successFunction) => ({
  type: PROCESS_RESERVATION_CART_REQUEST,
  successFunction
});

export const checkoutStep = (step, reservationCart) => ({
  type: RESERVATION_CHECKOUT_STEP_REQUEST,
  payload: {
    step,
    reservationCart
  }
});

// export const updatePasswordAndProcess = (
//   data,
//   originalReservationCart,
//   successFunction
// ) => ({
//   type: UPDATE_RESERVATION_CART_WITH_PASSWORD_AND_PROCESS_REQUEST,
//   data,
//   originalReservationCart,
//   successFunction
// });
